import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { PostsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const POSTS_QUERY = graphql`
query NodeAllPostsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Posts" } }) {
    nodes {
      data
    }
  }
}
`;

export const PostsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(POSTS_QUERY), 'items')}>{children}</Provider>;
};
